import { Helmet } from "react-helmet-async";

const SIGNUP_LINK = "https://slplc.lynmonkel.com/?mid=381754_2228817";

export default function CasinoSlotCasea() {
  return (
    <>
      <Helmet>
        <title>Casino Slot Casea - PlaySpiro</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div style={{minHeight:"100vh",background:"#0a0514",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"20px"}}>
        <div style={{width:"100%",maxWidth:"720px",borderRadius:"16px",overflow:"hidden",boxShadow:"0 0 60px rgba(168,85,247,0.3)",marginBottom:"28px",position:"relative",paddingTop:"56.25%"}}>
          <iframe
            src="https://player.cloudinary.com/embed/?cloud_name=stytzoif&public_id=video-ads_Za5JUZF1&autoplay=true&muted=true&loop=true&controls=false"
            allow="autoplay; fullscreen"
            allowFullScreen
            style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
          />
        </div>
        <a href={SIGNUP_LINK} target="_blank" rel="noopener noreferrer" style={{display:"inline-block",background:"linear-gradient(135deg,#a855f7,#7c3aed)",color:"#fff",fontWeight:"900",fontSize:"20px",padding:"16px 48px",borderRadius:"50px",textDecoration:"none",boxShadow:"0 0 30px rgba(168,85,247,0.5)",textAlign:"center"}}>
          SIGN UP & CLAIM BONUS
        </a>
        <p style={{color:"rgba(255,255,255,0.3)",fontSize:"11px",marginTop:"12px",textAlign:"center"}}>
          18+ Only - Gamble Responsibly - T&Cs Apply
        </p>
      </div>
    </>
  );
}
